import { MenuItem } from './../../menu/menu-item';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-menu-modulo-subitem2',
  templateUrl: './menu-modulo-subitem2.component.html',
  styleUrls: ['./menu-modulo-subitem2.component.css']
})
export class MenuModuloSubitem2Component implements OnInit {

  @Input() menu: MenuItem;
  @Input() bg: string = 'bg-danger';
  show: boolean = false;
  private hideTimeout: number | null = null;
  private readonly hideDelayMs = 150;

  constructor() { }

  ngOnInit() {
  }

  mostrar() {
    this.cancelarEsconder();
    this.show = true;
  }

  agendarEsconder() {
    if (this.hideTimeout != null) {
      clearTimeout(this.hideTimeout);
    }
    this.hideTimeout = window.setTimeout(() => {
      this.show = false;
      this.hideTimeout = null;
    }, this.hideDelayMs);
  }

  cancelarEsconder() {
    if (this.hideTimeout != null) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    this.show = true;
  }

  esconder() {
    this.show = false;
  }

}
